export default {
  filters: { nullable_author: false },
  paginationOptions: {},
  notifications: {},
  cronFrequency: 2 // minute, how often cron can dispatch notifications
};
